import React, { useContext } from 'react';
import { Tag } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import dayjs from 'dayjs';

import AmazonWebServicesContext from '@totem/components/administration/amazonWebServices/AmazonWebServicesContext';
import { statusColor } from '@totem/components/administration/amazonWebServices/AmazonWebServicesTable';
import { AwsStatusCostSummary } from '@totem/components/administration/amazonWebServices/types';
import IBTable from '@totem/components/ui_components/antDesignOverrides/IBTable';

const formatMonthLabel = (month: string) =>
  dayjs(`${month}-01`).format('MMM YYYY');

const formatCost = (value: string | undefined, currency: string) => {
  if (!value) {
    return '—';
  }

  const amount = Number.parseFloat(value);
  if (Number.isNaN(amount)) {
    return '—';
  }

  return amount.toLocaleString('en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  });
};

const AwsCostByStatusTable = () => {
  const { statusCostReport } = useContext(AmazonWebServicesContext);
  const { months, currency, statuses } = statusCostReport;

  const columns: ColumnProps<AwsStatusCostSummary>[] = [
    {
      title: 'Status',
      key: 'status',
      fixed: 'left',
      width: 220,
      render: (_, record) => (
        <Tag color={statusColor(record.status)}>{record.status}</Tag>
      ),
    },
    ...months.map((month) => ({
      title: formatMonthLabel(month),
      key: month,
      align: 'right' as const,
      width: 110,
      render: (_, record: AwsStatusCostSummary) => (
        <span>{formatCost(record.monthlyCosts[month], currency)}</span>
      ),
    })),
  ];

  return (
    <IBTable
      rowKey={(record) => record.status}
      columns={columns}
      dataSource={statuses}
      pagination={false}
      scroll={{ x: 'max-content' }}
    />
  );
};

export default AwsCostByStatusTable;
